<div id="managePopUp" *ngIf="conflictPopup">
  <div class="modal-header pd-xy-15 ">
    <h6 class="modal-title" id="modal-basic-title">{{authoringContentData?.changeService?.incompatibleServiceMsg }}</h6>
    <button type="button" class="close def-selected" aria-label="Close" (click)="onClickClose($event)">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <p>{{authoringContentData?.changeService?.serviceRemoveAdviceTxt}}<strong>{{selectedService.name ? selectedService.name : selectedService.description}}</strong>
      {{authoringContentData?.changeService?.serviceRemoveAdivceTxt_2}}
    </p>
    <ul>
      <li *ngFor="let service of currentConflictingServices">
        {{service.name ? service.name : service.description}}<span *ngIf="grandFatherCheck">{{' - '}}{{authoringContentData?.changeService?.grandFatherLabel}}</span></li>
    </ul>
  </div>
  <div class="modal-footer">
    <button mat-stroked-button (click)="onClickClose($event)" type="button"
      class="btn secondary_btn only-bdr-btn">{{authoringContentData?.changeService?.cancelTxt}}</button>
    <button mat-stroked-button (click)="removeAndContinue()" type="button"
      class="btn primary_btn order-sm-1">{{authoringContentData?.changeService?.removeServiceContinueTxt}}</button>
  </div>
</div>

<div id="k2kServiceConflictPopUp" *ngIf="k2kPopUp">
<div class="modal-header pd-xy-15 ">
  <h6 class="modal-title" id="modal-basic-title"*ngIf="restrictedInReviewTyp=='REMOVAL'">{{authoringContentData?.changeService?.serviceConflictModalRemoveTitle }}</h6>
  <h6 class="modal-title" id="modal-basic-title"*ngIf="restrictedInReviewTyp=='ADDITION' || k2kAddPopUp">{{authoringContentData?.changeService?.serviceConflictModalAddTitle }}</h6>
  <button type="button" class="close def-selected" aria-label="Close" (click)="onK2KClickClose($event)">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body" *ngIf="k2kAddPopUp">
  <span>{{authoringContentData?.changeService?.serviceConflictModalAddContent1}} {{selectedSvcName}} {{authoringContentData?.changeService?.onUsTxt}}</span>
   {{conflictSvcName}} {{authoringContentData?.changeService?.serviceConflictModalAddContent2}}{{authoringContentData?.changeService?.serviceConflictModalContact}}
</div>

<div class="modal-body" *ngIf="restrictedInReviewTyp=='REMOVAL'">    
  <span>{{authoringContentData?.changeService?.serviceConflictModalRemoveContent1}} {{selectedSvcName}} {{authoringContentData?.changeService?.onUsTxt}}</span>
  {{authoringContentData?.changeService?.serviceConflictModalRemoveContent2}} {{restConflictSvcName[zero]}} {{authoringContentData?.changeService?.orTxt}} {{restConflictSvcName[one]}}
  {{authoringContentData?.changeService?.serviceConflictModalRemoveContent3}}{{authoringContentData?.changeService?.serviceConflictModalContact}}  
</div>

<div class="modal-body" *ngIf="(restrictedInReviewTyp=='ADDITION' && !grandFatherCheck)">
  <span>{{authoringContentData?.changeService?.serviceConflictModalAddContent1}} {{selectedSvcName}} {{authoringContentData?.changeService?.onUsTxt}}</span>
  {{restConflictSvcName[zero]}} {{authoringContentData?.changeService?.andTxt}} {{restConflictSvcName[one]}}
  {{authoringContentData?.changeService?.serviceConflictModalAddContent2}} {{authoringContentData?.changeService?.serviceConflictModalContact}}
</div>

<div class="modal-body" *ngIf="(restrictedInReviewTyp=='ADDITION' && grandFatherCheck)">
  <span>{{authoringContentData?.changeService?.serviceConflictModalAddContent1}} {{selectedSvcName}} {{authoringContentData?.changeService?.onUsTxt}}</span>
  {{restConflictSvcName[zero]}} {{authoringContentData?.changeService?.andTxt}} {{restConflictSvcName[one]}} 
  {{authoringContentData?.changeService?.serviceConflictModalAddContent2}} {{authoringContentData?.changeService?.serviceConflictModalContact}}
</div>

<div class="modal-footer">
  <button mat-stroked-button (click)="onK2KClickClose($event)" type="button"
    class="btn secondary_btn only-bdr-btn">{{authoringContentData?.changeService?.cancelTxt}}</button>   
</div>
</div>



<div id="managePopUp" *ngIf="grandFatherPopup">
<div class="modal-header pd-xy-15 ">
  <h6 class="modal-title" id="modal-basic-title">{{authoringContentData?.changeService?.grandFatherPopupTitle }}</h6>
  <button type="button" class="close def-selected" aria-label="Close" (click)="closeGrand($event)">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <p>{{authoringContentData?.changeService?.grandFatherRemovalText}}</p>
</div>
<div class="modal-footer">
  <button mat-stroked-button (click)="closeGrand($event)" type="button"
    class="btn secondary_btn only-bdr-btn">{{authoringContentData?.changeService?.cancelTxt}}</button>
  <button mat-stroked-button (click)="removeGrand()" type="button"
    class="btn primary_btn order-sm-1">{{authoringContentData?.changeService?.removeServiceContinueTxt}}</button>
</div>
</div>

<div id="managePopUp" *ngIf="conflictingRedemptionSocPopup">
  <div class="modal-header pd-xy-15 ">
    <h6 class="modal-title" id="modal-basic-title">{{authoringContentData?.changeService?.conflictingRedemptionSocTitle }}</h6>
    <button type="button" class="close def-selected" aria-label="Close" (click)="onClickClose($event)">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  
  <div class="modal-body">
    <p>{{authoringContentData?.changeService?.conflictingRedemptionSocText}}</p>
  </div>
  </div>